import api from "../axios";

// SCRUM-962: Admin › Active Review Sessions. Uses the Reading Review v2
// "Executive dashboard" endpoints (outside the reading-review base path).

// Sessions left open in one account (`scope` = its schema_name): every
// `open_sessions` entry - active (a reviewer holds the lock) and paused
// (nobody in it, but still open until continued, completed or ended).
// Active ones first.
export const getActiveReviewSessions = async (scope) => {
  const { data } = await api.get("api/dashboards/kpis/reading-review-activity/", {
    params: { scope: scope || "all" },
  });
  const open = (data?.open_sessions || []).filter((s) => s.status === "active" || s.status === "paused");
  return open.sort((a, b) => (a.status === "active" ? 0 : 1) - (b.status === "active" ? 0 : 1));
};

// Ends the session (it becomes abandoned; saved work is kept). The removed
// reviewer's page finds out on its next call (409 session_closed).
export const endReviewSession = async (sessionId, accountId) => {
  const { data } = await api.post(
    `api/dashboards/kpis/reading-review-activity/sessions/${sessionId}/terminate/`,
    { account_id: accountId, mode: "end" }
  );
  return data;
};
